import { apiClient } from './apiClient';
import { createApiUrl } from '../utils/apiConfig';
import tokenStorage from '../utils/tokenStorage';

const base = '/api/sales/runs';
const integrationsBase = '/api/sales/integrations';

function authHeaders() {
  const headers = {};
  const token = tokenStorage.getAccessToken();
  if (token) headers.Authorization = `Bearer ${token}`;
  return headers;
}

export const salesService = {
  getIntegrations: () => apiClient.get(integrationsBase),
  putIntegrations: payload => apiClient.put(integrationsBase, payload),
  listRuns: () => apiClient.get(base),
  getRun: id => apiClient.get(`${base}/${id}`),
  createRun: payload => apiClient.post(base, payload),
  updateRun: (id, payload) => apiClient.put(`${base}/${id}`, payload),
  deleteRun: id => apiClient.del(`${base}/${id}`),
  listLeads: id => apiClient.get(`${base}/${id}/leads`),
  ingestRag: id => apiClient.post(`${base}/${id}/ingest-rag`, {}),
  startCalling: (id, payload = {}) =>
    apiClient.post(`${base}/${id}/start-calling`, payload),
  startEmail: (id, payload = {}) =>
    apiClient.post(`${base}/${id}/start-email`, payload),
  seedFromLibrary: (id, payload = {}) =>
    apiClient.post(`${base}/${id}/seed-from-library`, payload),
  approveLeads: (id, payload = {}) =>
    apiClient.post(`${base}/${id}/approve-leads`, payload),
  duplicateRun: (id, payload = {}) =>
    apiClient.post(`${base}/${id}/duplicate`, payload),
  followUpRun: (id, payload = {}) =>
    apiClient.post(`${base}/${id}/follow-up`, payload),
  retryN8n: id => apiClient.post(`${base}/${id}/retry-n8n`, {}),
  listWorkflowTemplates: (query = '') =>
    apiClient.get(`/api/sales/workflow-templates${query}`),
  searchSicCodes: (query = '') =>
    apiClient.get(`/api/sales/sic-codes${query}`),
  listEmailIdentities: () => apiClient.get('/api/sales/email-identities'),
  upsertEmailIdentity: payload => apiClient.put('/api/sales/email-identities', payload),
  processEmailReply: payload => apiClient.post('/api/sales/email-replies', payload),
  pauseRun: id => apiClient.post(`${base}/${id}/pause`, {}),
  resumeRun: id => apiClient.post(`${base}/${id}/resume`, {}),
  cancelRun: id => apiClient.post(`${base}/${id}/cancel`, {}),
  dialLead: (runId, leadId) =>
    apiClient.post(`${base}/${runId}/leads/${leadId}/dial`, {}),
  recordOutcome: (runId, leadId, payload) =>
    apiClient.post(`${base}/${runId}/leads/${leadId}/outcome`, payload),
  setDoNotCall: (runId, leadId, payload = {}) =>
    apiClient.post(`${base}/${runId}/leads/${leadId}/do-not-call`, payload),
  exportCsv: async id => {
    const resp = await fetch(createApiUrl(`${base}/${id}/export`), {
      method: 'GET',
      credentials: 'include',
      headers: authHeaders(),
    });
    if (!resp.ok) {
      const errText = await resp.text().catch(() => '');
      throw new Error(errText || `Export failed (${resp.status})`);
    }
    const disposition = resp.headers.get('Content-Disposition') || '';
    const match = disposition.match(/filename="?([^"]+)"?/i);
    const filename = match?.[1] || `leads_results_${id}.csv`;
    const blob = await resp.blob();
    return { filename, blob };
  },
};

export default salesService;
